import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FichaObraImpressaoComponent } from 'src/app/ficha-da-obra/ficha-obra-impressao/ficha-obra-impressao.component';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { CommonLoaderComponent } from 'src/app/shared/components/common-loader/common-loader.component';
import { environment } from 'src/environments/environment';
import { HomeService } from '../../home-service/home.service';
import { ListagemObrasComponent } from '../listagem-obras.component';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { ModulosBuscaService } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulos.service';
import { ObraNavegacaoService } from 'src/app/shared/services/obras-navegacao/obras-navegacao.service';

@Component({
  selector: 'app-minhas-obras',
  standalone: true,
  imports: [
    ListagemObrasComponent,
    CommonLoaderComponent,
    CommonModule,
    FormsModule,
  ],
  templateUrl: './minhas-obras.component.html',
  styleUrls: ['./minhas-obras.component.scss'],
})
export class MinhasObrasComponent implements OnInit {
  @ViewChild(ListagemObrasComponent)
  BASE_URL: string = environment.BASE_IMG_URL;
  listagemObrasComponent: ListagemObrasComponent;
  idSelecionado: number | null = null;
  companyId: string | null = null;
  loadingWorks: boolean = false;
  idObraSelecionada: number | null = null;
  selectedWorkIds: number[] = [];
  userID: string;

  obras: any[] = [];
  selectedRows: any[] = [];
  filtroTipoObraSelecionados: number[] = [];

  pageSize = 50;
  page = 1;
  totalItems = 0;

  termoBusca: string = '';
  searchType: string = 'obra';
  searchTerm: string = '';
  updateInterval: number | null = null;

  selecionados: Set<any> = new Set();
  colunaOrdenada: string = '';
  direcaoOrdenacao: 'asc' | 'desc' = 'asc';

  constructor(
    private readonly _homeService: HomeService,
    private readonly _fichaDaObraService: FichaDaObraService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly modalService: BsModalService,
    private readonly ngZone: NgZone,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: AuthService,
    private readonly obraNavegacaoService: ObraNavegacaoService,
    private readonly modulosBuscaService: ModulosBuscaService,
  ) {
    this.userID = this.authService.userID;
  }

  ngOnInit() {
    this.listMyWork();

    this.route.queryParams.subscribe((params) => {
      if (params['termo']) {
        this.termoBusca = params['termo'];
        this.cdr.detectChanges();
      }
    });
  }

  onAbrirEmpresa(empresa: any) {
    const termo = empresa.companyName;
    this.router.navigate(['/busca/empresa'], { queryParams: { termo } });
  }

  ordenarPor(coluna: string) {
    if (coluna === 'id') return;
    if (this.colunaOrdenada === coluna) {
      this.direcaoOrdenacao = this.direcaoOrdenacao === 'asc' ? 'desc' : 'asc';
    } else {
      this.colunaOrdenada = coluna;
      this.direcaoOrdenacao = 'asc';
    }
    this.obras = [...this.obras].sort((a, b) => {
      let aValue = a[coluna] ?? '';
      let bValue = b[coluna] ?? '';
      if (!isNaN(Number(aValue)) && !isNaN(Number(bValue))) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      } else {
        aValue = aValue.toString().toLowerCase();
        bValue = bValue.toString().toLowerCase();
      }
      if (aValue < bValue) return this.direcaoOrdenacao === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.direcaoOrdenacao === 'asc' ? 1 : -1;
      return 0;
    });
  }

  onSelectionChange(selected: any[]) {
    this.selecionados = new Set(selected.map((item) => item.id));
    this.selectedRows = selected;
  }

  onPageChange(novaPagina: number) {
    this.page = novaPagina;
    this.listMyWork();
  }

  abrirFichaObra(workID: number, obra: any): void {
    if (!workID) {
      console.error('workID inválido.');
      return;
    }

    const ids = this.obras.map((o) => o.id);
    if (!ids.length) {
      console.error('Lista de obras vazia.');
      return;
    }

    const nomeModulo = this.getRotaModulo(obra);
    if (!nomeModulo) {
      console.error('Módulo não encontrado para a obra:', obra);
      return;
    }

    this.obraNavegacaoService.setObraIds(ids, nomeModulo);
    this.router.navigate(['/buscas', nomeModulo, 'detalhes', workID]);
  }

  private mapObra(item: any): any {
    return {
      id: item.workId,
      modulos: item.module,
      moduleId: item.moduleId ?? item.moduleID,
      companyID: item.companyID ?? '',
      ufCidade:
        (item.stateName ? ' ' + item.stateName : '') +
        ' - ' +
        (item.cityName ? item.cityName : ''),
      empresa: item.companyName || '-',
      obra: item.workName,
      fase: item.phase,
      tipo: item.type,
      valor: item.valueDolar,
      padrao: item.pattern,
      res: item.responsible,
      atualizada: item.workUpdateDate
        ? `Atualizada em: ${this.formatarData(item.workUpdateDate)}`
        : '',
    };
  }

  listMyWork(): void {
    this.loadingWorks = true;
    let selectedModuleIds: string | null = null;
    if (this.filtroTipoObraSelecionados.length > 0) {
      if (Array.isArray(this.filtroTipoObraSelecionados)) {
        selectedModuleIds = this.filtroTipoObraSelecionados.join(', ');
      } else {
        selectedModuleIds = String(this.filtroTipoObraSelecionados);
      }
    }
    const body = {
      idListWorkOfHome: 1,
      moduleID: selectedModuleIds,
      searchType: this.searchType || null,
      searchTerm: this.searchTerm || null,
      updateInterval: this.updateInterval || null,
      pagination: {
        page: this.page,
        pageSize: this.pageSize,
        shortcuts: 10,
        ordenation: '',
      },
    };
    this._homeService.listWorksHome(body).subscribe({
      next: (response) => {
        if (response && response.data && Array.isArray(response.data.records)) {
          this.totalItems =
            response.data.recordsCount || response.data.records.length;
          this.page = response.data.page || 1;
          this.pageSize = response.data.pageSize || 50;
          this.obras = response.data.records.map((item: any) =>
            this.mapObra(item),
          );
          this.selectedWorkIds = this.obras.map((o) => o.id);
        } else {
          this.obras = [];
          this.selectedWorkIds = [];
        }
        this.loadingWorks = false;
      },
      error: (err) => {
        console.error('Erro ao buscar minhas obras:', err);
        this.loadingWorks = false;
      },
    });
  }
  onTiposObraSelecionadosChange(tipos: number[]) {
    this.filtroTipoObraSelecionados = tipos;
    this.page = 1;
    this.listMyWork();
  }

  onSearchEnter() {
    this.page = 1;
    this.searchWorks();
  }

  onSearchTypeChange(value: string) {
    this.searchType = value;
  }

  onSearchTermChange(value: string) {
    this.searchTerm = value;
  }

  onUpdateIntervalChange(value: number | null) {
    this.updateInterval = value;
    this.page = 1;
    this.listMyWork();
  }

  searchWorks(): void {
    this.loadingWorks = true;
    let selectedModuleIds: string | null = null;
    if (this.filtroTipoObraSelecionados.length > 0) {
      if (Array.isArray(this.filtroTipoObraSelecionados)) {
        selectedModuleIds = this.filtroTipoObraSelecionados.join(', ');
      } else {
        selectedModuleIds = String(this.filtroTipoObraSelecionados);
      }
    }

    const body = {
      idListWorkOfHome: 1,
      moduleID: selectedModuleIds,
      searchType: this.searchType || null,
      searchTerm: this.searchTerm || null,
      pagination: {
        page: this.page,
        pageSize: this.pageSize,
        shortcuts: 10,
        ordenation: '',
      },
    };
    this._homeService.listWorksHome(body).subscribe({
      next: (response) => {
        if (response && response.data && Array.isArray(response.data.records)) {
          this.totalItems =
            response.data.recordsCount || response.data.records.length;
          this.page = response.data.page || 1;
          this.pageSize = response.data.pageSize || 50;
          this.obras = response.data.records.map((item: any) =>
            this.mapObra(item),
          );
          this.selectedWorkIds = this.obras.map((o) => o.id);
        } else {
          this.obras = [];
          this.selectedWorkIds = [];
        }
        this.loadingWorks = false;
      },
      error: (err) => {
        console.error('Erro ao buscar obras:', err);
        this.loadingWorks = false;
      },
    });
  }

  formatarData(data: string): string {
    const d = new Date(data);
    if (isNaN(d.getTime())) return '';
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  onPageSizeChange(novoPageSize: number) {
    this.pageSize = novoPageSize;
    this.page = 1;
    this.listMyWork();
  }

  impressaoFicha(): void {
    const obraIdsSelecionadas = Array.from(this.selecionados)
      .filter((id) => id !== undefined)
      .map((id) => id);

    if (!obraIdsSelecionadas || obraIdsSelecionadas.length === 0) {
      alert('Por favor selecione ao menos uma obra para impress\u00E3o.');
      return;
    }

    const obrasSelecionadas = this.obras.filter((obra) =>
      obraIdsSelecionadas.includes(obra.id),
    );

    this.loadingWorks = true;
    const body = {
      workDetails: obrasSelecionadas.map((obra) => ({
        workId: String(obra.id),
        moduleId: String(obra.moduleId || 0),
      })),
    };
    this._fichaDaObraService.infoImpressao(body).subscribe({
      next: (response) => {
        this.loadingWorks = false;
        if (response.success && response.data.works.length > 0) {
          const modalRef = this.modalService.show(FichaObraImpressaoComponent, {
            initialState: {
              dadosApi: response.data,
            },
            class: 'modal-lg',
          });
          if (modalRef.content) {
            modalRef.content.modalRef = modalRef;
          }
          this.selecionados.clear();
          this.selectedRows = [];
          if (this.listagemObrasComponent) {
            this.listagemObrasComponent.limparSelecao();
          }
        } else {
          console.error('Nenhuma obra encontrada na resposta:', response);
        }
      },
      error: (error) => {
        this.loadingWorks = false;
        console.error('Erro ao buscar detalhes da impressão:', error);
      },
    });
    return;
  }

  downloadPDFFicha(): void {
    this.loadingWorks = true;

    const obraIdsSelecionadas = Array.from(this.selecionados)
      .filter((id) => id !== undefined)
      .map((id) => id);

    const obrasSelecionadas = this.obras.filter((obra) =>
      obraIdsSelecionadas.includes(obra.id),
    );

    const body = {
      workDetails: obrasSelecionadas.map((obra) => ({
        workId: String(obra.id),
        moduleId: String(obra.moduleId || 0),
      })),
    };
    this._fichaDaObraService.downloadPDF(body).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Obras_equipes.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.loadingWorks = false;
        this.selecionados.clear();
        this.selectedRows = [];
        if (this.listagemObrasComponent) {
          this.listagemObrasComponent.limparSelecao();
        }
      },
      error: (err) => {
        console.error('Erro ao baixar o PDF:', err);
        this.loadingWorks = false;
      },
    });
  }

  emitirSelecaoVazia() {
    const listagemObras = document.querySelector('app-listagem-obras');
    if (listagemObras) {
      const event = new CustomEvent('selectionChange', { detail: [] });
      listagemObras.dispatchEvent(event);
    }
  }

  abrirDetalhesObra(item: any): void {
    const workID = item.id ?? item.workId;
    if (workID) {
      this._homeService.markWorksSeen(workID).subscribe({
        next: (res) => {},
        error: (err) => {
          console.error(
            '[abrirDetalhesObra] Erro ao marcar obra como visualizada:',
            err,
          );
        },
      });
    }

    this.abrirFichaObra(workID, item);
  }

  private getRotaModulo(obra: any): string | null {
    const moduloId = Number(obra?.moduleId ?? obra?.moduleID ?? 0);
    if ([2, 3, 4, 234].includes(moduloId)) return 'imobiliario';
    if (moduloId) return this.modulosBuscaService.getRotaById(moduloId);

    const nomeModulo = String(obra?.modulos ?? obra?.module ?? '').trim();
    const moduloNormalizado = nomeModulo
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    const rotas: Record<string, string> = {
      imobiliario: 'imobiliario',
      industrial: 'industrial',
      edificacoes: 'edificacoes',
      infraestrutura: 'infraestrutura',
    };

    return rotas[moduloNormalizado] ?? null;
  }

  private getNomeModulo(idSelecionado: number): string {
    switch (idSelecionado) {
      case 5:
        return 'Industrial';
      case 6:
        return 'Edificações';
      case 7:
        return 'Infraestrutura';
      default:
        return '';
    }
  }

  private getTypeIdByModulo(idSelecionado: number): string {
    switch (idSelecionado) {
      case 5:
        return '2';
      case 6:
        return '1';
      case 7:
        return '3';
      default:
        return '';
    }
  }
}
